<template lang="pug">
v-container(fluid class=" tw-h-full tw-w-full")
  v-row(no-gutters align="center" justify="center" class="tw-w-full tw-h-full")
    v-col(class="tw-rounded-md tw-h-full tw-w-full tw-ml-2 tw-flex tw-flex-col ")
      v-row(class="  tw-flex !tw-flex-shrink-default ")
        v-col
          span(class="tw-text-2xl tw-text-indigo-lighten-1 tw-font-bold tw-capitalize") {{ $t('Profile.Common.updatePassword') }}
      v-row(align="start" class="  tw-flex tw-flex-row !tw-flex-grow-defaul tw-h-full ")
        v-col(cols="6")
          v-form(ref="form" v-model="valid" lazy-validation)
            v-row(no-gutters)
              v-col
                v-text-field(
                  v-model="password.current"
                  :rules="currentPasswordRules"
                  :label="$t('Profile.Common.currentPassword')"
                  type="password"
                  outlined
                  class="tw-capitalize"
                )
            v-row(no-gutters)
              v-col
                v-text-field(
                  v-model="password.new"
                  :rules="passwordRules"
                  type="password"
                  :label="$t('Profile.Common.newPassword')"
                  :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="passwordVisible ? 'text' : 'password'"
                  @click:append="togglePasswordVisibility"
                  outlined
                  class="tw-capitalize"
                )
            v-row(no-gutters)
              v-col
                v-text-field(
                  v-model="password.confirm"
                  :rules="passwordConfirmRules"
                  :label="$t('Profile.Common.confirmPassword')"
                  :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="passwordVisible ? 'text' : 'password'"
                  @click:append="togglePasswordVisibility"
                  outlined
                  class="tw-capitalize"
                )

      v-row(no-gutters justify="end" class="  tw-flex tw-flex-row !tw-flex-shrink-default")
        v-col(cols="auto" align-self="end")
          v-btn(
            elevation="0"
            @click="update"
            :loading="loading"
            color="rgba(94,129,244,0.80)"
            class="tw-bg-kPurple tw-rounded"
          ) {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      password: {},
      passwordVisible: false,
      valid: false,
      loading: false,
      currentPasswordRules: [(v) => !!v || 'Please enter your current password'],
      passwordRules: [(v) => !!v || 'Please enter a new password'],
      passwordConfirmRules: [
        (v) => !!v || 'Please repeat your password',
        (v) => v === this.password.new || 'Passwords do not match',
      ],
    };
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const payload = new FormData();
        payload.append('current_password', this.password.current);
        payload.append('password', this.password.new);
        payload.append('_method', 'put');
        this.$store.dispatch('user/updatePassword', payload).then(() => {
          this.loading = false;
          this.$refs.form.reset();
        });
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>
